import React from 'react';

import Status404 from '../../../../error/404';
import { WordpressData } from '../../@types/Wordpress';
import { ContentType } from '../../utilities/WordpressConstants';
import { BlogContent } from '../BlogContent/BlogContent';
import { EmptyContent } from '../EmptyContent/EmptyContent';
import { PageContent } from '../PageContent/PageContent';

export type ContentRouterProps = {
  contentType: ContentType;
  data: WordpressData | null;
  isSSR: boolean;
};

export const ContentRouter: React.FC<ContentRouterProps> = ({ contentType, data, isSSR }) => {
  switch (contentType) {
  case ContentType.PAGE:
    return <PageContent {...{ data }} />;
  case ContentType.BLOG:
    return <BlogContent {...{ data, isSSR }} />;
  case ContentType.EMPTY:
    return <EmptyContent message={typeof data === 'string' ? data : 'No posts to show.'} />;
  case ContentType.ERROR:
  default:
    return <Status404 />;
  }
};
